import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';
import { Observable } from 'rxjs';

import { CommonWindow } from '@core/domain/models/common-window.model';
import { CorePaymentMethod } from '@core/domain/models/payments.models';
import { ConfigService } from '@core/infrastructure/config/config.service';
import { CoreTimestampServerService } from '@core/infrastructure/time/server/timestamp-server.service';

@Injectable()

/**
 * Service to manage static resources
 */
export class StaticResourceService {
    public static: string;

    public domain: string;

    public path: any = {};

    public webStandard: string;

    constructor(
        private readonly configService: ConfigService,
        private readonly http: HttpClient,
        private readonly timestampSvc: CoreTimestampServerService,
        @Inject(WINDOW) private readonly window: CommonWindow,
    ) {
        this.initializeUrls();
    }

    public getDomain() {
        return this.domain;
    }

    public getLib(libname: string): string {
        const libpath = `${this.path.libs}${libname}.js?t=${this.timestampSvc.getTs()}`;
        return libpath;
    }

    public getMedia() {
        return this.path.media;
    }

    public getImage(image, timestamp) {
        if (timestamp) {
            return `${this.path.images}${image}?t=${this.timestampSvc.getTs()}`;
        }

        return `${this.path.images}${image}`;
    }

    public getMediaPath(path: string, timestamp?: boolean): string {
        const url: URL = new URL(`${this.getMedia()}${path}`);

        if (timestamp) {
            url.searchParams.append('t', this.timestampSvc.getTs());
        }

        return url.toString();
    }

    public getStatic() {
        return this.static;
    }

    public getIcon(icon: string) {
        return `${this.path.icons}${icon}?t=${this.timestampSvc.getTs()}`;
    }

    /**
     * @name getPaymentLogo
     * @methodOf  common.service:ItxStaticResourceSvc
     * @description
     * Get payment icon
     * @param method - Payment method object
     * @returns Icon path
     */
    public getPaymentLogo(method: Pick<CorePaymentMethod, 'code'>, _extension = 'png'): string {
        if (!method) {
            return null;
        }

        let url = this.getPaymentMethodImageUrl(method, 'png');

        // TODO ECOMDUTI-20963 Remove test urls
        url = url.replace('staticPruStg', 'statici');
        url = url.replace('itxwebstandard', 'itxstandard');
        url = url.replace('.png', '_activo.png');

        return url;
    }

    private getPaymentMethodImageUrl(paymentMethod: Pick<CorePaymentMethod, 'code'>, extension: string): string {
        let url = this.window.location.protocol === 'https:' ? this.path.payments.replace('http:', 'https:') : this.path.payments.replace('https:', 'http:');

        url += url.slice(-1) === '/' ? '' : '/';

        const ts = this.timestampSvc.getTs();

        url += `${paymentMethod.code}.${extension}?${ts}`;

        return url;
    }

    public getRelateds(target: string): Observable<any> {
        const ts = this.timestampSvc.getTs();
        const url = `/relateds/${target}.json?ts=${ts.toString()}`;
        return this.http.get<any>(url);
    }

    private initializeUrls() {
        // Check if assetsUrl already contains static2 to avoid misconfiguration between Java and Node server
        const assetsUrl = this.configService.getConfigUrl<string>('assetsUrl');
        const assetsUrlWithStaticPath = assetsUrl.includes('static2') ? assetsUrl : `${assetsUrl}/static2`;

        this.static = assetsUrlWithStaticPath;

        this.webStandard = `${this.static}/itxwebstandard/`;
        this.path.images = `${this.webStandard}/images/`;
        this.path.icons = `${this.webStandard}/icons/`;
        this.path.payments = `${this.static}/itxstandard/images/payment/`;
        this.path.media = `${this.static}/media`;
        this.path.libs = `${this.static}itxwebstandard/libs/`;
    }
}
